import React, { useState } from "react";
import { CiCircleInfo } from "react-icons/ci";
import { LuChevronDown } from "react-icons/lu";

export const BillingDetails = () => {
  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };
  return (
    <div className="w-full  lg:px-6 lg:py-4 overflow-x-scroll lg:w-[90%] xl:w-full hidescroll">
      <h1 className="text-[28px] md:text-[32px]">Billing Details</h1>
      <p>Manage billing information and tax details</p>
      <div className="md:flex md:space-x-4 w-full">
        <div className="bg-[#f0f0f0] dark:bg-[#282828] w-full  rounded-lg p-6 mt-4">
          <div className="md:flex items-center justify-between">
            <h1 className="text-[28px]">Billing Type</h1>
            <div className="py-3 md:py-0 flex items-center space-x-4 justify-between">
              <p>
                Same as <span className="underline">Buyer</span>
              </p>

              <div
                onClick={handleToggle}
                className={`cursor-pointer w-12 rounded-full ${
                  isToggled ? "bg-[#46BA58]" : "bg-[#5B5B5B]"
                } p-[2px] `}
              >
                <div
                  className={`w-5 h-5 rounded-full bg-white dark:bg-[#1c1c1c] ${
                    isToggled ? "translate-x-[22px]" : ""
                  }`}
                />
              </div>
            </div>
          </div>
          <label htmlFor="address">Address</label>
          <br />
          <input
            className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full  rounded-lg border px-4 py-3 bg-transparent"
            name="email"
            type="email"
            placeholder="Furtunei 28, et.2 , sector 6"
          />
          <br />
          <div className="w-full  flex-col lg:flex-row flex items-center lg:space-x-2">
            <div className="relative w-full">
              <label htmlFor="Country">Country</label>
              <br />
              <select
                name="countries"
                className="custom-select bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full rounded-lg border px-4 py-3 bg-transparent"
                id="countries"
              >
                <option value="Romania">Romania</option>
                <option value="Romania">Romania</option>
                <option value="Romania">Romania</option>
                <option value="Romania">Romania</option>
              </select>
              <LuChevronDown className='text-xl  absolute right-2 top-12'/>
            </div>
            <div className="w-full">
              <label htmlFor="City">City</label>
              <br />
              <input
                className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full rounded-lg border px-4 py-3 bg-transparent"
                name="City"
                type="text"
                placeholder="Romania"
              />
            </div>
            <div className="w-full">
              <label htmlFor="Zip">Zip or Postal Code</label>
              <br />
              <input
                className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full rounded-lg border px-4 py-3 bg-transparent"
                name="City"
                type="text"
                placeholder="Romania"
              />
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <input
              className="bg-white dark:border-gray-600 "
              type="checkbox"
              name=""
              id=""
            />
            <p>Check if you want to invoice as a company</p>
          </div>
        </div>
        <div className="bg-[#f0f0f0] w-full dark:bg-[#282828]  rounded-lg p-6 mt-4">
          <h1 className="text-[28px]">Company Details</h1>
          <div className="flex items-center space-x-2 py-4">
            <input
              className="bg-white dark:border-gray-600 "
              type="checkbox"
              name=""
              id=""
            />
            <p>VAT Deductible</p>
          </div>
          <label htmlFor="company">Company/Organization Name</label>
          <br />
          <input
            className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full  rounded-lg border px-4 py-3 bg-transparent"
            name="company"
            type="text"
            placeholder="S.C Premium UI Kits S.R.L"
          />
          <br />
          <div className="flex items-center space-x-2">
            <label htmlFor="company">Company Identification Number</label>
            <CiCircleInfo className="text-white" />
          </div>

          <input
            className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full  rounded-lg border px-4 py-3 bg-transparent"
            name="company"
            type="text"
            placeholder="e.q. Romania Code: ROXXXXXXXXX"
          />
          <br />
          <div className="md:flex items-center md:space-x-4 justify-between">
            <div className="flex items-center space-x-2">
              <p>VAT ID</p>
              <CiCircleInfo className="text-white" />
            </div>
            <div className="flex items-center space-x-2 py-4">
              <input
                className="dark:border-gray-600 "
                type="checkbox"
                name=""
                id=""
              />
              <p>Same as Company Identification Number</p>
            </div>
          </div>
          <input
            className="bg-white dark:border-gray-600 mb-2 dark:bg-[#1C1C1C] w-full  rounded-lg border px-4 py-3 bg-transparent"
            name="VatId"
            type="text"
            placeholder="e.q. Romania Code: ROXXXXXXXXX"
          />
          <br />
          <label htmlFor="company">Company Address</label>
          <br />
          <input
            className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full  rounded-lg border px-4 py-3 bg-transparent"
            name="company"
            type="text"
            placeholder="Furtunei 28, et.2 , sector 6"
          />
        </div>
      </div>
      <button className="w-full mt-4 md:w-fit px-2 py-2 bg-[#1c1c1c] rounded-lg dark:bg-white dark:text-[#1c1c1c] text-white mb-4 text-lg">
        Save Details
      </button>
    </div>
  );
};
